import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { NestedListItem } from '../../NestedListItem/NestedListItem';
import { TelexItem } from './TelexItem/TelexItem';

export const TelexList = memo(({ telegrams, styles, onOfpClick, onClickTelegram, onAttachmentClick, getStyle }) => {
    const telexCodes = Object.keys(telegrams).sort();
    const { t: translate } = useTranslation();

    return (
        <NestedListItem
            showSign={false}
            inset={false}
            style={styles.listItemWithBorder}
            primary={translate('labels.telegrams')}
            disabled={!telexCodes.length}
        >
            {telexCodes.map((code) => (
                <TelexItem
                    key={code}
                    telegram={telegrams[code]}
                    onAttachmentClick={onAttachmentClick}
                    onClick={code === 'CFP' ? onOfpClick : onClickTelegram}
                    getStyle={getStyle}
                />
            ))}
        </NestedListItem>
    );
});

TelexList.defaultProps = {
    telegrams: {},
    styles: {},
    onClickTelegram: () => {},
    onOfpClick: () => {},
    onAttachmentClick: () => {},
};
